/* Elysian product hero (v4): size tiles and the grind chips pick the variant by option values; Dawn's product-form handles the add.
   2026-09-28, purchase choice (snippets/elysian-subscribe.liquid): Subscribe / One-time tiles and the frequency chips. One-time is
   preselected from 2026-09-29 (Chris: "It feels sneaky"); nothing here assumes either, the state is read from the checked radio.
   Real mode: the tiles are the form's selling_plan radios; Subscribe carries the chosen plan id, prices come from the variant's
   selling_plan_allocations. Review mode (no selling plans yet): the radios are outside the form, so the add is one-time; prices use
   the preview discount. Every state change is instant. */
(function () {
  function bind(root) {
    if (root.dataset.elyBound) return;
    root.dataset.elyBound = '1';
    var data = root.querySelector('[data-ely-variants]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var sizePos = parseInt(root.dataset.sizePos, 10) || 0;
    var grindPos = parseInt(root.dataset.grindPos, 10) || 0;
    var idInput = root.querySelector('[data-ely-variant-id]');
    var button = root.querySelector('[data-ely-submit]');
    var label = button ? button.querySelector('span') : null;
    /* grind: chips (radios, round 2) or the select when a product has more than 6 grind values */
    var grindEls = root.querySelectorAll('[data-ely-grind]');
    function grindValue() {
      if (!grindEls.length) return null;
      if (grindEls[0].tagName === 'SELECT') return grindEls[0].value;
      var c = root.querySelector('[data-ely-grind]:checked');
      return c ? c.value : null;
    }
    var sub = root.querySelector('[data-ely-sub]');
    /* review mode never shows on the published theme (the Liquid checks theme.role too) */
    if (sub && sub.dataset.mode === 'mock' && window.Shopify && Shopify.theme && Shopify.theme.role === 'main') { sub.parentNode.removeChild(sub); sub = null; }
    var subRadio = sub ? sub.querySelector('[data-ely-purchase-subscribe]') : null;
    var frequency = sub ? sub.querySelector('[data-ely-frequency]') : null;
    function money(cents) {
      cents = Math.round(cents);
      return '$' + (cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2));
    }
    function subscribing() { return !!(subRadio && subRadio.checked); }

    function current() {
      var sizeEl = root.querySelector('[data-ely-size]:checked');
      var size = sizeEl ? sizeEl.value : null;
      var g = grindValue();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (sizePos && v.options[sizePos - 1] !== size) continue;
        if (grindPos && g !== null && v.options[grindPos - 1] !== g) continue;
        return v;
      }
      return null;
    }
    function updateVariant() {
      var v = current();
      if (!button) return;
      if (!v) { button.disabled = true; if (label) label.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = v.id;
      root.dataset.variantId = v.id;
      button.disabled = !v.available;
      if (label) label.textContent = !v.available ? 'Sold Out' : (subscribing() ? (sub.dataset.button || 'Subscribe') : 'Add to Cart');
      updatePrices(v);
    }
    /* subscription price of a variant for the chosen plan: its selling plan allocation (real) or the preview discount (review mode) */
    function subPrices(v) {
      var plan = sub.querySelector('[data-ely-plan]:checked');
      var price = v.price, compare = v.price;
      if (sub.dataset.mode === 'real') {
        var allocs = v.selling_plan_allocations || [];
        for (var i = 0; i < allocs.length; i++) {
          if (plan && String(allocs[i].selling_plan_id) === plan.value) { price = allocs[i].price; compare = allocs[i].compare_at_price || v.price; }
        }
      } else {
        price = Math.round(v.price * (100 - (parseInt(sub.dataset.mockPct, 10) || 0)) / 100);
      }
      return { price: price, compare: compare };
    }
    /* "Ships free" star (2026-09-28): a size tile shows it when its price for the current purchase choice meets that choice's
       free-shipping threshold (section settings, cents on the section). Instant; a 150ms scale-in only when it appears after a
       switch, never on first paint (CSS drops it for reduced motion). */
    var freeOne = parseInt(root.dataset.freeOneTime, 10) || 0, freeSub = parseInt(root.dataset.freeSub, 10) || 0;
    var shipFirst = true;
    function variantFor(size) {
      var g = grindValue();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (sizePos && v.options[sizePos - 1] !== size) continue;
        if (grindPos && g !== null && v.options[grindPos - 1] !== g) continue;
        return v;
      }
      return null;
    }
    /* one wiggle (CSS ely-shipfree-wiggle); restarting it on a repeat pick */
    function wiggle(badge) { badge.classList.remove('is-wiggle'); void badge.offsetWidth; badge.classList.add('is-wiggle'); }
    root.addEventListener('animationend', function (e) { if (e.animationName === 'ely-shipfree-wiggle') e.target.classList.remove('is-wiggle'); });
    function updateShipFree() {
      /* without a purchase choice (filter coffees) the one-time threshold applies */
      var on = !!sub && subscribing();
      root.querySelectorAll('[data-ely-size]').forEach(function (r) {
        var badge = r.parentNode.querySelector('[data-ely-shipfree]');
        var v = variantFor(r.value);
        if (!badge || !v) return;
        var price = on ? subPrices(v).price : v.price;
        var min = on ? freeSub : freeOne;
        var show = min > 0 && price >= min;
        var appears = show && badge.hidden && !shipFirst;
        badge.hidden = !show;
        if (appears) wiggle(badge);
      });
      shipFirst = false;
    }
    function updatePrices(v) {
      if (!sub || !v) return;
      var sp = subPrices(v), price = sp.price, compare = sp.compare;
      var saved = compare - price, pct = saved > 0 && compare > 0 ? Math.round(saved * 100 / compare) : 0;
      var t = sub.querySelector('[data-ely-sub-title]'), p = sub.querySelector('[data-ely-sub-price]'), o = sub.querySelector('[data-ely-onetime-price]'), s = sub.querySelector('[data-ely-sub-save]');
      if (t) t.textContent = pct > 0 ? sub.dataset.titleSave.replace('[percent]', pct) : sub.dataset.title;
      if (p) p.textContent = money(price);
      if (o) o.textContent = money(v.price);
      if (s) { s.hidden = saved <= 0; if (saved > 0) s.textContent = sub.dataset.pill.replace('[amount]', money(saved)); }
      updateShipFree();
    }
    function updatePlan() {
      if (!sub) return;
      var on = subscribing();
      if (frequency) frequency.hidden = !on;
      var plan = sub.querySelector('[data-ely-plan]:checked');
      /* real mode: the Subscribe radio is the form's selling_plan, so it carries the chosen plan */
      if (sub.dataset.mode === 'real' && subRadio && plan) subRadio.value = plan.value;
      updateVariant();
    }
    /* savings pill lift (card standard rule 9): marks a chosen size, so only a pick lifts the pill, never the preselected tile on load */
    var tiles = root.querySelector('.ely-size-tiles');
    root.querySelectorAll('[data-ely-size]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (tiles && !tiles.hasAttribute('data-ely-chosen')) tiles.setAttribute('data-ely-chosen', '');
        updateVariant();
        var badge = r.parentNode.querySelector('[data-ely-shipfree]');
        if (badge && !badge.hidden) wiggle(badge);
      });
    });
    grindEls.forEach(function (el) { el.addEventListener('change', updateVariant); });
    /* keyboard ring fallback: WebKit drops :focus-visible when the arrow keys move within a radio group, so the group marks keyboard
       use itself (any key) and clears it on pointer down; the CSS shows the ring for :focus-visible or [data-ely-kbd] :focus */
    root.querySelectorAll('.ely-grind__chips, .ely-sub__options').forEach(function (chips) {
      chips.addEventListener('keydown', function () { chips.setAttribute('data-ely-kbd', ''); });
      chips.addEventListener('pointerdown', function () { chips.removeAttribute('data-ely-kbd'); });
    });
    /* Recharge's widget adds its own selling_plan fields to the form (a select and a hidden input) once the product has plans; later
       fields win, so they would override this choice. Disable every selling_plan field that is not ours, now, on change and on submit. */
    var form = subRadio && subRadio.form;
    function quietRecharge() {
      if (!form) return;
      var els = form.elements;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.name === 'selling_plan' && !el.hasAttribute('data-ely-purchase-subscribe') && !el.hasAttribute('data-ely-purchase-onetime')) el.disabled = true;
      }
    }
    if (form) {
      quietRecharge();
      form.addEventListener('submit', quietRecharge, true);
      if (window.MutationObserver) new MutationObserver(quietRecharge).observe(form, { childList: true, subtree: true });
    }
    if (sub) {
      var options = sub.querySelector('.ely-sub__options');
      sub.querySelectorAll('[data-ely-purchase-subscribe], [data-ely-purchase-onetime]').forEach(function (r) {
        r.addEventListener('change', function () { if (options && !options.hasAttribute('data-ely-chosen')) options.setAttribute('data-ely-chosen', ''); updatePlan(); });
      });
      sub.querySelectorAll('[data-ely-plan]').forEach(function (r) { r.addEventListener('change', updatePlan); });
    }
    updatePlan();
    updateVariant();
  }
  function init() { document.querySelectorAll('[data-ely-product]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
